import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import IconButton from "../components/molecules/IconButton";
import Navbar from "../components/Navbar";
import { SEARCH } from "../constants/routesPaths";
import { analytics } from "../firebase.config";

import heroImage from "../assets/images/hero-image.png";
import sectionImage from "../assets/images/mascota-ideal.png";
import adoptziHelps from "../assets/images/adoptzi_helps.png";
import oneGreen from "../assets/svgs/one_green.svg";
import twoGreen from "../assets/svgs/two_green.svg";
import threeGreen from "../assets/svgs/three_green.svg";
import adoptziStep1 from "../assets/images/adoptzi_step1.png";
import adoptziStep2 from "../assets/images/adoptzi_step2.png";
import adoptziStep3 from "../assets/images/adoptzi_step3.png";

function Home(props) {
  let mainClass = "home";

  analytics.logEvent(`Page_Home`, {});

  let goToSearch = (doPush = true) => {
    analytics.logEvent(`Action_SearchPet`, {});
    if (doPush) {
      props.history.push(SEARCH);
    }
  };

  let goToSearchHowitWorks = () => {
    analytics.logEvent(`Action_SearchPetHowItWorks`, {});
  };

  return (
    <div>
      <div className={mainClass}>
        <Navbar customClasses={"navbar--relative"}>
          <a href={"/"} className={"navbar__links"}>
            Inicio
          </a>
          <Link
            to={SEARCH}
            className={"navbar__links navbar__links--button"}
            onClick={() => {
              goToSearch({
                doPush: false,
              });
            }}
          >
            Buscar mascota
          </Link>
        </Navbar>
        <div className={`${mainClass}-hero`}>
          <div className={`${mainClass}-hero-container`}>
            <div className={`${mainClass}-hero-info`}>
              <h1 className={`${mainClass}-hero-info_title`}>
                ¿Buscas adoptar una mascota en Guatemala?
              </h1>
              <div className={"icon-button-wrapper"}>
                <IconButton
                  buttonText="Buscar mi mascota"
                  goTo={SEARCH}
                  onClick={goToSearch}
                  image={"svgs/search_white_icon.svg"}
                  position={"left"}
                />
              </div>
            </div>
          </div>
          <div className={`${mainClass}-hero-image`}>
            <img
              src={heroImage}
              alt={"Encuentra a tu mascota ideal en Adoptzi"}
            />
          </div>
        </div>
        <div className={`${mainClass}-mainIdea`}>
          <div className={`${mainClass}-mainIdea-container`}>
            <img src={sectionImage} alt={"Mascota ideal en Adoptzi"} />
            <h2 className={`${mainClass}-mainIdea-container_title`}>
              Tu mascota ideal te espera
            </h2>
            <p className={`${mainClass}-mainIdea-container_text`}>
              Encuentra el mejor acompañante en Adoptzi. Nuestro sistema te
              ayudará en la adopción de tu mascota basado en lo que realmente
              buscas.
            </p>
            <div className={"icon-button-wrapper"}>
              <IconButton
                buttonText="Buscar mi mascota"
                goTo={SEARCH}
                onClick={goToSearch}
                image={"svgs/search_white_icon.svg"}
                position={"left"}
              />
            </div>
          </div>
        </div>
        <div className={`${mainClass}-steps`}>
          <div className={`${mainClass}-steps-container`}>
            <h2 className={"text-align-center"}>¿Cómo funciona Adoptzi?</h2>
            <div className={`${mainClass}-steps-information`}>
              <div className={`${mainClass}-steps-information--item`}>
                <div className={`${mainClass}-steps-information--item_image order-flex-first`}>
                  <img src={adoptziStep1} alt={"Paso 1 en Adoptzi"} />
                </div>
                <div className={`${mainClass}-steps-information--item_text ${mainClass}-steps-information--item_text--left order-flex-second`}>
                  <h3>BUSCA</h3>
                  <p>
                    Utiliza nuestro buscador para recomendarte mediante el uso de inteligencia artificial las mascotas que se adapten a tus gustos.
                  </p>
                  <p className={`${mainClass}-steps-information--item_text--button`}>
                  <Link onClick={() => {
                      goToSearchHowitWorks();
                    }} to={SEARCH}>Empieza aquí
                    </Link>
                  </p>
                </div>
              </div>
              <div className={`${mainClass}-steps-information--item`}>
                <div className={`${mainClass}-steps-information--item_text ${mainClass}-steps-information--item_text--right order-flex-second`}>
                  <h3>ENCUENTRA</h3>
                  <p>
                    Te estaremos <span className={'bold-text'}>recomendando</span> la mejor opción que se adapte a ti. Navega a través de todos los resultados y conoce las mascotas que más te gusten.
                  </p>
                </div>
                <div className={`${mainClass}-steps-information--item_image order-flex-first`}>
                  <img src={adoptziStep2} alt={"Paso 2 en Adoptzi"} />
                </div>
              </div>
              <div className={`${mainClass}-steps-information--item`}>
                <div className={`${mainClass}-steps-information--item_image order-flex-first`}>
                  <img src={adoptziStep3} alt={"Paso 3 en Adoptzi"} />
                </div>
                <div className={`${mainClass}-steps-information--item_text ${mainClass}-steps-information--item_text--left order-flex-second`}>
                  <h3>¡ADOPTA!</h3>
                  <p>
                    Decide cuáles mascotas quieres conocer y empieza la aventura con quién puede ser tu futura mascota.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`${mainClass}-helpingOthers`}>
          <div className={`${mainClass}-helpingOthers-container`}>
            <div
              className={`${mainClass}-helpingOthers-container_columns build-columns`}
            >
              <div
                className={`${mainClass}-helpingOthers-image one-third-column`}
              >
                <img src={adoptziHelps} alt={"En Adoptzi queremos apoyar"} />
              </div>
              <div
                className={`${mainClass}-helpingOthers-container-information two-third-column`}
              >
                <h2 class>
                  Nosotros también estaremos <span>apoyando</span>
                </h2>
                <div className={`${mainClass}-helpingOthers-text_information`}>
                  <p>
                    Toda donación o ayuda recibida hacia Adoptzi, estaremos
                    dando parte de lo recaudado para apoyar a los refugios o
                    casas que ayudan a la adopción de mascotas en Guatemala que
                    aún no tienen un hogar.
                  </p>
                  <p className={"mg-top-16"}>
                    Si quieres apoyar a esta causa puedes contactarnos al correo{" "}
                    <a href={"mailto:ciscgaldamez@gmail.com"}>
                      ciscgaldamez@gmail.com
                    </a>
                    {" "}o deja tus datos{" "}
                    <a target={"_blank"} rel={"noreferrer"} href={"https://airtable.com/shrKimUO8A9UTCf93"}>
                      en este formulario
                    </a>
                    {" "}y nosotros nos pondremos en contacto lo más pronto posible.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <h1>¿Buscas perro en adopcion en Guatemala?</h1> */}
      </div>
      <Footer />
    </div>
  );
}

export default Home;
